import { NoteFeature } from "@/@types";

type Props = {
    noteFeatures?: NoteFeature[];
    title?: string;
};

export default function UsedProductNoteFeaturesTable({ noteFeatures, title }: Props) {
    if (!noteFeatures || noteFeatures.length === 0) return null;

    const sorted = noteFeatures
        .slice()
        .sort((a, b) => a.concept.localeCompare(b.concept, "es"));

    return (
        <div className="mb-6">
            {title && (
                <h3 className="font-bold mb-2 uppercase text-sm">{title}</h3>
            )}

            <table className="w-full text-sm border">
                <thead>
                    <tr className="bg-gray-100">
                        <th className="text-left pl-4 py-2">MEDIDA</th>
                        <th className="text-center py-2">VALOR</th>
                    </tr>
                </thead>
                <tbody>
                {sorted.map((item, index) => (
                    <tr key={index} className="border-t">
                        <td className="py-2 pl-4 border-r">
                            {item.concept}
                        </td>
                        <td className="py-2 text-center">
                            {item.value || item.note || "-"}
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
}